import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import RequestQuote from "@/pages/RequestQuote";
import CustomerPortal from "@/pages/CustomerPortal";
import StaffLogin from "@/pages/staff/StaffLogin";
import StaffLayout from "@/pages/staff/StaffLayout";
import Dashboard from "@/pages/staff/Dashboard";
import Builds from "@/pages/staff/Builds";
import Customers from "@/pages/staff/Customers";
import Invoices from "@/pages/staff/Invoices";
import Quotes from "@/pages/staff/Quotes";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#09090b] text-yellow-500 font-display">LOADING…</div>;
  if (!user) return <Navigate to="/staff/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster theme="dark" position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:category" element={<ServicePage />} />
            <Route path="/request-quote" element={<RequestQuote />} />
            <Route path="/portal" element={<CustomerPortal />} />
            <Route path="/staff/login" element={<StaffLogin />} />
            <Route path="/staff" element={<Protected><StaffLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="builds" element={<Builds />} />
              <Route path="customers" element={<Customers />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="quotes" element={<Quotes />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
